import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=804228fc"
import script from "./notification.ts?vue&type=script&lang=ts&external"
export * from "./notification.ts?vue&type=script&lang=ts&external"
import style0 from "./notification.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports